<template>
<div class="train">
  <div class="container">
    <div class="linkBox clearfix">
      <div class="item">
          <div class="inner">
              <div class="item-header clearfix">
                  <span class="title">合作单位</span>
                  <i class="fa el-icon-arrow-down"></i>
              </div>
              <div class="item-body" style="display: block;">
                  <ul class="clearfix">
                      <li v-for="(link,index) in hz_links" :key="index"><a :href="link.url" >{{link.name}}</a></li>
                  </ul>
              </div>
          </div>
      </div>
      <div class="item">
          <div class="inner">
              <div class="item-header clearfix">
                  <span class="title">行业分站</span>
                  <i class="fa el-icon-arrow-down"></i>
              </div>
              <div class="item-body" style="display:;">
                  <ul class="clearfix">
                       <li v-for="(link,index) in fz_links" :key="index"><a :href="link.url" >{{link.name}}</a></li>
                  </ul>
              </div>
          </div>
      </div>
      <div class="item">
          <div class="inner">
              <div class="item-header clearfix">
                  <span class="title">友情链接</span>
                  <i class="fa el-icon-arrow-down"></i>
              </div>
              <div class="item-body" style="display:;">
                  <ul class="clearfix">
                       <li v-for="(link,index) in yq_links" :key="index"><a :href="link.url" >{{link.name}}</a></li>
                  </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {},
  components: {},
  data() {
    return {
      hz_links: [],
      fz_links: [],
      yq_links: [],
      global,
      selink1:"--合作单位--",
      selink2:"--行业分站--",
      selink3:"--友情链接--"
    };
  },

  mounted() {
    this.$axios
      .get("/api/links?sort=-createdAt&limit=100")
      .then((res) => {
        if (res.data) {
          for (var i = 0; i < res.data.data.length; i++) {
            if(res.data.data[i].type == "合作平台")
            {
              this.hz_links.push(res.data.data[i]);
            }else if(res.data.data[i].type == "行业分站")
            {
              this.fz_links.push(res.data.data[i]);
            }else if(res.data.data[i].type == "友情链接")
            {
              this.yq_links.push(res.data.data[i]);
            }
          }
        }
      })
      .catch((err) => {
        this.web_links = [
          {
            url: "http://www.mohurd.gov.cn/",
            name: "中华人民共和国住房和",
          },
          {
            url: "http://www.chinacoal.gov.cn/templet/3/",
            name: "中国煤炭工业网",
          },
          {
            url: "http://www.cweun.org/",
            name: "中国水利工程协会",
          },
          {
            url: "http://www.coalchina.org.cn/",
            name: "中国煤炭工业协会",
          },
          {
            url: "http://www.ciesc.cn/",
            name: "中国化工学会",
          },
          {
            url: "http://www.chinasafety.ac.cn/",
            name: "中国安全生产科学研究",
          },
        ];
      });
  },

  methods: {
    openLink(url){
      window.open(url)
    }
  },
  watch: {
    selink1(newVal){
      window.open(newVal)
    },
    selink2(newVal){
      window.open(newVal)
    },
    selink3(newVal){
      window.open(newVal)
    }
  }
};
</script>

<style scoped>
.train{
  margin-bottom: 28px;
}
</style>
